module.exports = __webpack_public_path__ + "img/fire.d018354d.svg";